import _ from '/home/ps/root'
import { INDEX, Ref, getLoginRow, Fields, copy, cookies, cache, session} from '../global'
import {lang} from '../reducer/initial-state'
// import {IO, tact} from '../io'
import {/*go, localhost, act, dispatch,*/ tcp} from '../io'
const ID = 'action'
Ref[ID] = {}
const init = (u, us) => {
  // console.log(`init ${u} ${us}`)
  // console.log({[ID]: 'init', u, us})
  console.log({[ID]: 'init', u, us})
  return {type: 'init', u, lang, v: us}
}
const u = (route, param, url) => {
  // console.log(`U ${route} ${url}`)
console.log({[ID]: 'u', route, param, url})
// console.log(ID, {u: 'u', route, param, url})
  return {type: 'u', route, url, param}
}
const __q__ ={}
// let __stagePk__ =0
var __qpk__ = 0
export const getQ = () => __q__
// export const setQ = q => __q__=copy(q)
export default {
  // find: (who='missing', what='vendor') => ({type: 'find', what, who}),
  find: (who='missing', what='vendor') => {
    // debugger
    console.log({[ID]: 'find', who, what})
    // console.log(ID, {find: 'find', who, what})
    // console.log({[ID]: 'init', u, us})
    return {type: 'find', what, who}
  },
  // ['select']: select => ({type: 'select', ...select}),
  slide: (id = '', state = 'hide', socket) => ({type: 'slide', id, state, socket}),
  // ['buy']: q =>
  q:  q => {
    Object.keys(__q__).forEach(k => delete(__q__[k]))
    Object.keys(q).forEach(k => __q__[k] = copy(q[k]))
    console.log({[ID]: 'q', __q__})
    console.log({'qpark': 'q', __q__, q})
    return {type: 'q', ...q}
  },
  cart:  ({ localPurchase, remotePurchase, callback }) => {
    // debugger
    console.log({ [ID]: 'cart', localPurchase, remotePurchase, callback })
    return { type: 'cart', localPurchase, remotePurchase, callback }
  },
  online:  data => {debugger
    console.log({[ID]: 'online', data})
    return {type: 'online', data}
  },
  user:  (uid, u/*, merge=false*/) => {
    console.log({[ID]: 'user', uid, u})
    const prop = copy(Ref.store.getState().master)
    const user = prop.user
    // const {lock, ...usr} = user[uid] || {}
    const lastId = Object.keys(user).pop()
    const lastIndex = user[lastId]?.index
    const nextIndex = lastIndex ? lastIndex+1 : 1
    const Q = prop.q
    const qs = Object.keys(__q__)
    const stagePk = isNaN(uid)
console.log({'qpark': 'pre', uid, user: copy(user), __q__: copy(__q__), Q})
    if (uid && u) { // adding u
      var park = false
      qs.forEach(key => {
        const q = __q__[key]
        if (q.uid == uid && user[uid].q == key) { // already present
          park = true
          // __q__[key] = {...q, ...user}
          user[uid] = {...user[uid], ...u}
          // if (!u.lock) delete(user[uid].lock)
        }
      })
      qs.forEach(key => {
        const q = __q__[key]
        if (!park && (q.type=='text' || stagePk) && !q.uid) { // not present
          __q__[key].uid = uid
          park = true
          u.q = key
          console.log({'qpark': 'adding q', uid, user: copy(user), __q__: copy(__q__), Q})
        }
      })
      if (!park) { // not added due to lack of Q
        const type = stagePk ? 'stage' : 'text'
        const k = `${--__qpk__}.0.${type}`
        __q__[k] = {type, expire: 0, life: 0, uid}
        u.q = k
      }
      user[uid] = {...user[uid], ...u}
      user[uid].index = user[uid].index || nextIndex
      console.log({'qpark': 'added', uid, user: copy(user), __q__: copy(__q__), Q})
    } else if (uid) { // removing user
      qs.forEach(key => {
        const q = __q__[key]
        if (q.uid==uid) {
          const [qpk, i, type] = key.split('.')
          if (qpk<0) delete(__q__[key])
          else delete(__q__[key].uid)
          delete(Ref.user[uid])
        }
      })
      delete(user[uid])
      console.log({'qpark': 'removing', uid, user: copy(user), __q__: copy(__q__), Q})
    } else { // going offline
      // delete(window.ps.qq)
      Object.keys(__q__).forEach(k => delete(__q__[k]))
      Object.keys(Q).forEach(k => __q__[k]=Q[k])
      Object.keys(user).forEach(id => delete(user[id]))
      console.log({'qpark': 'offline', uid, user: copy(user), __q__: copy(__q__), Q})
      Ref.user = {}
    }
   console.log({'qpark': 'post', uid, user: copy(user), __q__: copy(__q__), Q})
    return {type: 'user', ...user}
  },
  purchase: row => ({type: 'purchase', ...row}),
  new: blank => ({type: 'new', ...blank}),
  connect: (connected) => ({ type: 'connect', connected }),
  init: (id, app = 'master') => init(id, app),
  initresponse: r => {
    const _init = Ref.store.getState().master.init
    const init = copy(Object.assign({}, _init, {[r.v]: r}))
    return {type: 'init', init}
  },
  // u: (route, param, url = `${window.location.pathname}${window.location.search}`) => {return u(route, param, url)},
  u: (route, param, url = `${window.location.pathname}${window.location.search}`) => u(route, param, url),
  requestresponse: action => ({...action, type: 'response'}),
  partresponse: action => ({...action, type: 'partresponse'}),
  purchaseresponse: r => {
    return { type: 'purchase', purchase }
  },
  presponse: r => {
    // const p = { ...copy(IO.getState().master.p) }
    const p = { ...Ref.store.getState().master.p }
    // const p = { ...props.p }
    if (r.vendor) {
      p.vendor = getLoginRow(r.vendor)
      const vpark = `p${r.vendor[0]}`
      p[vpark] = r[vpark] || false
      Ref[vpark] = p[vpark]
    }
    console.log({[ID]: 'p', p})
    return { type: 'p', p }
  },
  parkresponse: r => {
    const props = Ref.store.getState().master
    // const props = copy({ ...Ref.store.getState().master })
    const cookie = cookies()
    // const park = props.park
    const park = copy(props.park)
    const p = park

    // let vendor = r.vendor
// r.vendorif (!r.vendor)debugger
    // const vendor = Array.isArray(r.vendor) ? getLoginRow(r.vendor) ? r.vendor
    // const vendor = r.vendor && Array.isArray(r.vendor) && getLoginRow(r.vendor)
    // if (vendor) {
//       if (Array.isArray(vendor)) {
//         vendor = getLoginRow(vendor)
//         // const vid = vendor[0]
//         // vendor = {
//         //   id: vendor[0],
//         //   modified: vendor[1],
//         //   home: vid == _.QID ? cookie.p : vendor[2],
//         //   username: vendor[3],
//         //   password: vendor[4],
//         //   name: vendor[5],
//         //   phone: vendor[6],
//         //   email: vendor[7],
//         //   json: vendor[8],
//         // }
//         // park.vendor = vendor
//       }
// if (vendor.e) debugger
    // if (r.vendor) {
    //   park.vendor = getLoginRow(r.vendor)
    //   const vpark = `p${r.vendor[0]}`
    //   park[vpark] = r[vpark] || false
    //   IO[vpark] = park[vpark]
    // }
      // const ps_vid = r[vpark]
      // if (typeof ps_vid != 'undefined') {
      //   const [pvid, svid] = typeof ps_vid == 'string' ? ps_vid.split(',') : [ps_vid]
      //   park[vpark] = pvid
      //   park[`s${vendor['id']}`] = svid
      // }
    // }
    var type, state, view, s, active
    const lang = r.lang || props.lang
    const verb = r.verb || 'default'
    if (r.map) park.map = r.map
    // if (r['map']) debugger
    if (r.ref) park.ref = r.ref
    const u = r.u || 'store'
    // const route = r.route
    // const buffer = r.buffer || {}
    Object.keys(r.buffer || {}).reduce((hosts, host) => {
      Object.keys(r.buffer[host]).reduce((vs, v) => {
        if (!p[v]) p[v] = {}
        const vLogin = v=='login'
        Object.keys(r.buffer[host][v]).reduce((dbs, db) => {
if (db=='find') {debugger;return dbs}
          if (_.VERB_.includes(db)) {
            p[v][db] = r.buffer[host][v][db]
            return dbs
          }
  // if (v!='qq' && !vendor)debugger
          // const db = _db=='find' ? vendor.id : _db
  if (!db)debugger
          const store = r.buffer[host][v][db]
          switch (v) {
            case 'cart':
            case 'suggest':
            case 'recommend':
            case 'error':
            p[v][db] = store
            return dbs
          }
          if (!p[v][db]) p[v][db] = {}
          const where = store.where
          if (where) {
            if (where=='valid') {
              const valid = store.valid
              p[v][db].valid = valid
              p[v][db][valid] = store[valid]
            }
            p[v][db].where = where
            p[v][db][where] = store[where]
          }
          const count = store.count
          if (count) {
            p[v][db].count = count
            p[v][db][count] = store[count]
          }
          const all = store.all
          if (all) debugger
          const modified = store.modified
          if (modified) p[v][db].modified = modified
          const offset = store.offset || 0
          const print = store.print || _.PUB
          const meta = `${offset}${print}`
          if (store[meta]) p[v][db][meta] = store[meta]
          if (store[print]) p[v][db][print] = store[print]
          // const rv = r.verb
          // const rpk = r.pk
          Object.keys(store).reduce((verbs, verb)=> {
            // if (!_.SQL_.includes(verb)) return verbs
            if (!_.VERB_.includes(verb)) return verbs
            const rows = store[verb]
            if (rows && !p[v][db][verb]) p[v][db][verb]={}
            switch (verb) {
              case 'default':
              if (db=='user' && props.new[db] && cookie.login) delete p[v][db].default[props.new[db][v]]
              break
              // case _.DEF: debugger
              // case _.UPD: debugger
              // case _.INS: debugger
              // p[v][db][rv][rpk] = rows[rpk]
              break
              case 'delete':
              Object.keys(rows).reduce((pks, pk) => {
                delete(p[v][db].default[pk])
                const vkey = `${lang}${db}${v}`
                if (vLogin) {
                  session(session(pk).username, null)
                  session(pk, null)
                  session(`${pk}[]`, null)
                  // session(`${pk}[]`, null)
                  session('otp', null)
                  if (__DEV__) {
                    const policy = `path=/;SameSite=Strict;`
                    document.cookie = `login=;max-age=0;${policy}`
                    document.cookie = `id=-${Math.floor(Math.random()*pk)};${policy}`
                    document.cookie = `username=master;${policy}`
                    document.cookie = `home=;max-age=0;${policy}`
                    document.cookie = `name=;max-age=0;${policy}`
                  }
                } else {
                  cache(vkey, null)
                  cache(`${vkey}${pk}`, null)
                  cache(`${vkey}${pk}[]`, null)
                }
                return pks
              }, {})
              delete(p[v][db][`0${_.PUB}`])
              // no break
              case 'update':
              case 'insert':
              case 'bulk': if (!vLogin) debugger
              // if (v!='login') tcp({buffer: {[v]: {[db]: {default: [], count: _.PUB}}}}, cookie.home, false)
              if (!vLogin) {debugger;tcp({buffer: {[cookie.home]: {[v]: {[db]: {default: [], count: _.PUB}}}}}, false)}
              default:
              return verbs
            }
            // if (verb==_.DEL) {
              // Object.keys(rows).reduce((pks, _pk) => {
              //   const [status, pk] = rows[_pk] // pk and _pk is same
              //   if (status && pk==_pk) {
              //     delete(p[v][db][_.DEF][pk])
              //     const vkey = `${lang}${db}${v}`
              //     cache(vkey, null)
              //     cache(`${vkey}${pk}`, null)
              //     cache(`${vkey}${pk}[]`, null)
              //     if (v==_.LOGIN) {
              //       const policy = `path=/;SameSite=Strict${__DEV__ ? '' : `;domain=.${_.DOMAIN};secure=1`}`
              //       if (__DEV__) document.cookie = `${_.LOGIN}=;${policy}`
              //     }
              //   }
              //   return pks
              // }, {})
              // return verbs
            // }
            Object.keys(rows||{}).reduce((pks, pk) => {
              p[v][db][verb][pk] = rows[pk]
  // if (v!=_.LOGIN && pk>83)debugger
              return pks
            }, {})
            return verbs
          }, {}) // verbs
          // if ((db < 0 || isStage(db)) && Object.keys(p[v][db][_.DEF]).length == 0) delete(p[v][db])
          if (p[v] && p[v][db] && p[v][db].default && Object.keys(p[v][db].default).length == 0) delete(p[v][db])
          return dbs
        }, {}) // dbs, db
        return vs
      }, {}) // vs, v
      return hosts
    }, {}) // hosts, host
    Object.keys(p).reduce((vs, v) => {
      const vLogin = v=='login'
      Object.keys(p[v]).reduce((dbs, db) => {
        if (_.VERB_.includes(db)) return dbs // printer
        const store = p[v][db] || {}
        Object.keys(store).reduce((verbs, vrb) => {
          if (!_.SQL_.includes(vrb)) return verbs
          const rows = store[vrb]
          Object.keys(rows).reduce((pks, pk) => {
            const printer = p[v][vLogin ? verb : 'default']
            if (!printer && _.Q_.includes(v)) return pks
            if (Array.isArray(rows[pk])) {
              if (_.Q_.includes(v) || v=='page') {
                var j=0
                rows[pk] = Object.keys(printer.view.field).reduce((fs, f, i) => {
                  if (f==v || !printer.view.field[f]) return fs
                  fs[f] = rows[pk][j++]
                  return fs;
                }, {})
              } else if (vLogin && rows[pk]!='find') {
                rows[pk] = getLoginRow(rows[pk])
                // let k = 0
                // // rows[pk] = rows[pk].reduce((fs, f, i) => {
                // const print = printer ? printer[_.VIEW][_.FIELD] : rows[pk]
                // rows[pk] = Object.keys(print).reduce((fs, f, i) => {
                //   if (!printer) {
                //     switch (i) {
                //       case 0: fs[_.ID] =       rows[pk][i]; return fs
                //       case 1: fs[_.MODIFIED] = rows[pk][i]; return fs
                //       case 2: fs[_.HOME] =     rows[pk][i]; return fs
                //       case 3: fs[_.USERNAME] = rows[pk][i]; return fs
                //       case 4: fs[_.PASSWORD] = rows[pk][i]; return fs
                //       case 5: fs[_.NAME] =     rows[pk][i]; return fs
                //       case 6: fs[_.PHONE] =    rows[pk][i]; return fs
                //       case 7: fs[_.EMAIL] =    rows[pk][i]; return fs
                //       case 8: fs[_.JSON] =     rows[pk][i]; return fs
                //     }
                //   } else {
                //     if (f==v || !print[f]) return fs
                //     fs[f] = rows[pk][k++]
                //   }
                //   return fs
                // }, {})
              }
            } // if (Array.isArray(rows[pk])) {
            // if (pk>0 && rows[pk] && typeof rows[pk]=='object' && !vLogin) {
            if (rows[pk] && typeof rows[pk]=='object' && !vLogin) {
              const key = `${lang}${db}${v}${pk}`
              if (pk > 0) cache(key, rows[pk])
              else if (isNaN(pk)) session(key, rows[pk])
              if (v=='follow') {debugger
                cache(`${db}from${rows[pk].from}`, rows[pk])
              }
            }
            return pks
          }, {}) // pks.foreach
          return verbs
        }, {}) // verbs
        return dbs
      }, []) // db
      return vs
    }, {}) // v
    console.log({ [ID]: 'park', park })
    if (r.callback) r.callback(park)
    return { type: 'park', park }
  },
  screen: (width, height) => ({type: 'screen', width, height}),
}
